import { Outlet, NavLink, useParams } from 'react-router-dom';
import { useState, useEffect } from 'react';
import api from '../services/api';

export default function ProjectLayout() {
    const { id } = useParams();
    const [project, setProject] = useState<any>(null);

    const [pendingCount, setPendingCount] = useState(0);

    useEffect(() => {
        if (id) {
            // Requisitions for this specific project
            api.get(`/api/obras/${id}/requisicoes`)
                .then(res => {
                    if (res.data.status === 'success') {
                        const pending = res.data.data.filter((r: any) => r.status === 'pendente').length;
                        setPendingCount(pending);
                    }
                })
                .catch(err => console.error(err));

            api.get(`/api/obras/${id}`)
                .then(response => {
                    if (response.data.status === 'success') {
                        setProject(response.data.data);
                    }
                })
                .catch(err => console.error("Erro ao carregar obra", err));
        }
    }, [id]);

    const tabs = [
        { label: 'Timeline', path: 'timeline' },
        { label: 'Cronograma', path: 'cronograma' },
        { label: 'RDO', path: 'rdo' },
        { label: 'Orçamento', path: 'orcamento' },
        { label: 'Custos', path: 'financeiro' },
        { label: 'Estoque', path: 'estoque' },
        { label: 'Requisições', path: 'requisicoes', badge: pendingCount },
    ];

    return (
        <div className="max-w-[95%] mx-auto px-4 sm:px-6 lg:px-8 py-8">
            {/* Cover Image */}
            <div className="w-full h-48 md:h-64 bg-gray-300 rounded-xl overflow-hidden mb-8 relative group">
                <img
                    src="https://images.unsplash.com/photo-1541888946425-d81bb19240f5?q=80&w=1000&auto=format&fit=crop"
                    alt="Capa da Obra"
                    className="w-full h-full object-cover"
                />

                {/* Overlay with details */}
                <div className="absolute inset-0 bg-black/50 hover:bg-black/60 transition-colors flex flex-col justify-end p-6">
                    {project ? (
                        <div className="text-white">
                            <h1 className="text-3xl font-bold mb-2">{project.nome_obra}</h1>
                            <div className="flex flex-wrap gap-4 text-sm md:text-base opacity-90">
                                <span className="flex items-center gap-1">
                                    <i className="ri-map-pin-line"></i>
                                    {project.endereco}
                                </span>
                                <span className="flex items-center gap-1">
                                    <i className="ri-user-star-line"></i>
                                    Eng. João Silva
                                </span>
                                <span className="flex items-center gap-1">
                                    <i className="ri-calendar-event-line"></i>
                                    Entrega: {project.data_fim_prevista ? new Date(project.data_fim_prevista).toLocaleDateString() : 'N/A'}
                                </span>
                            </div>
                        </div>
                    ) : (
                        <div className="h-20 w-1/3 bg-white/20 animate-pulse rounded"></div>
                    )}
                </div>

                <button className="absolute bottom-4 right-4 bg-white/90 hover:bg-white text-gray-800 px-4 py-2 rounded-lg text-sm font-medium shadow-sm opacity-0 group-hover:opacity-100 transition-opacity">
                    <i className="ri-camera-line mr-2"></i>
                    Alterar Capa
                </button>
            </div>

            {/* Tabs */}
            <div className="border-b border-gray-200 mb-8">
                <nav className="-mb-px flex space-x-8 overflow-x-auto" aria-label="Tabs">
                    {tabs.map((tab) => (
                        <NavLink
                            key={tab.path}
                            to={`/obras/${id}/${tab.path}`}
                            className={({ isActive }) =>
                                `whitespace-nowrap py-4 px-1 border-b-2 font-medium text-sm transition-colors ${isActive
                                    ? 'border-teal-500 text-teal-600'
                                    : 'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-300'
                                }`
                            }
                        >
                            {tab.label}
                            {tab.badge ? (
                                <span className="ml-2 px-1.5 py-0.5 bg-red-100 text-red-600 rounded-full text-xs font-bold">
                                    {tab.badge}
                                </span>
                            ) : null}
                        </NavLink>
                    ))}
                </nav>
            </div>

            {/* Content */}
            <Outlet />
        </div>
    );
}
